// Appearance preference (Astra §3.12): follow the system, or force light / dark. Kept in this browser only.
export type Theme = 'system' | 'light' | 'dark'
const KEY = 'mg_theme'

export function readTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'light' || v === 'dark' ? v : 'system'
  } catch {
    return 'system'
  }
}

/** System removes the override, so prefers-color-scheme decides. */
export function applyTheme(theme: Theme) {
  const root = document.documentElement
  if (theme === 'system') root.removeAttribute('data-theme')
  else root.setAttribute('data-theme', theme)
  try {
    if (theme === 'system') localStorage.removeItem(KEY)
    else localStorage.setItem(KEY, theme)
  } catch { /* the choice still applies to this visit */ }
}
